<template lang="html">
  <div class="">
      <p>{{vuexState}}</p>
      <hr>
      <p>{{articles.articleId}}</p>

  </div>
</template>

<script>
export default {
    name: 'ProductPage',
    data: () => ({
        vuexProductState: null//
    }),
    computed: {
        vuexState() {
            let temp = this.$store.state.products.productID.ipSumArticleId
            // this.celebPages = this.$store.state.celebPages
            // return celebPages
            return temp
        },
        articles() {
            let temp = this.$store.state.articles[0]
            return temp
        }
    }
}
</script>

<style lang="css">
</style>
